import axios from '@/shared/axios';
import { HelpCenterCategoryList, HelpCenterContentModal } from '@/types/help';
import { BaseResponse } from '@/types/web.interface';

// 获取帮助中心分类列表
export async function getHelpCenterCategoryList() {
  const res = await axios.get<BaseResponse<HelpCenterCategoryList>>(`/how-to/classify/list`);
  return res.data;
}

// 获取帮助中心文章详情
export async function getHelpCenterContent(titleId: string) {
  const res = await axios.get<BaseResponse<HelpCenterContentModal>>(`/how-to/content/${titleId}`);
  return res.data;
}

// 点赞帮助中心文章
export async function likeHelpCenterContent(id: string) {
  const res = await axios.post<BaseResponse<any>>(`/how-to/content/${id}/like`);
  return res.data;
}

// 点踩帮助中心文章
export async function dislikeHelpCenterContent(id: string) {
  const res = await axios.post<BaseResponse<any>>(`/how-to/content/${id}/dislike`);
  return res.data;
}
